import React, {useEffect} from "react";
import {useHistory, useParams} from "react-router";
import {uketori} from "@/api/exchange";
import {isLogin} from "@/util/authentication";
import {setRedirect} from "@/util/redirection";
import {getCard} from "@/api/card";

/**
 * 受け取り用のURL
 * QRからアクセスされる空ページ
 */
const Uketori = () => {
  const {cardId, code} = useParams()
  const history = useHistory()

  useEffect(() => {
    (async () => {
      const login = await isLogin()
      if (!login) {
        setRedirect(history.location.pathname)
        document.location.href = '/login'
        return <></>
      }

      try {
        const card = await getCard({ id: cardId })
        if (window.confirm(`${card.name}さんの名刺を受け取りますか？`)) {
          await uketori({ cardId, code })
        }
      } finally {
        history.push(`/uketori`)
      }
    })()
  }, [cardId, code, history])

  return (
    <></>
  )
}

export default Uketori
